export default {
  "hero_title": "Kakobuy Spreadsheet Polska – Największa baza najlepszych produktów Kakobuy",
  "hero_subtitle": "Znajdź sprawdzone linki, najlepsze produkty, sneakersy, streetwear oraz aktualne zestawienia Kakobuy Spreadsheet w jednym miejscu.",
  "cta_spreadsheet": "🔥 Sprawdź najnowszy Kakobuy Spreadsheet",
  "cta_buy_now": "Kup teraz na Kakobuy",
  "trust_updated": "Aktualizowane listy produktów",
  "trust_guides": "Przewodniki dla Polski",
  "trust_compare": "Porównania zakupowe",
  "trust_safety": "Bezpieczeństwo użytkownika",
  "what_is_title": "Czym jest Kakobuy Spreadsheet?",
  "what_is_content": "Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom szybciej znaleźć najlepsze oferty, linki zakupowe oraz popularne produkty z Chin. Dzięki przejrzystemu arkuszowi kalkulacyjnemu możesz w kilka sekund porównać ceny, jakość i opinie na temat tysięcy produktów – od sneakersów, przez odzież streetwear, aż po akcesoria i elektronikę.",
  "how_it_works_title": "Jak to działa?",
  "step1_title": "Znajdź produkt",
  "step1_desc": "Przeglądaj kategorie i znajdź interesujący Cię produkt z Chin.",
  "step2_title": "Sprawdź Kakobuy Spreadsheet",
  "step2_desc": "Skorzystaj z gotowych arkuszy z linkami i porównaj oferty.",
  "step3_title": "Porównaj jakość i cenę",
  "step3_desc": "Zobacz oceny, opinie i zdjęcia QC przed zakupem.",
  "step4_title": "Kup przez Kakobuy",
  "step4_desc": "Złóż zamówienie przez sprawdzoną platformę Kakobuy.",
  "categories_title": "Kategorie Kakobuy Spreadsheet",
  "categories_subtitle": "Wybierz kategorię i odkryj najlepsze produkty w naszych arkuszach",
  "comparison_title": "Kakobuy Spreadsheet vs tradycyjne wyszukiwanie",
  "comparison_col1": "Kakobuy Spreadsheet",
  "comparison_col2": "Tradycyjne wyszukiwanie",
  "comparison_feature": "Funkcja",
  "comparison_links": "Gotowe linki",
  "comparison_categories": "Kategorie produktów",
  "comparison_time": "Oszczędność czasu",
  "comparison_beginners": "Dla początkujących",
  "safety_title": "Czy Kakobuy Spreadsheet jest bezpieczny?",
  "safety_content": "Nasza strona jest niezależnym przewodnikiem informacyjnym. Nie sprzedajemy produktów i nie obsługujemy płatności. Kakobuy Spreadsheet to wyłącznie narzędzie ułatwiające wyszukiwanie i porównywanie produktów.",
  "safety_tip1": "Sprawdź sprzedawcę przed zakupem",
  "safety_tip2": "Czytaj opinie innych kupujących",
  "safety_tip3": "Zawsze sprawdzaj zdjęcia QC",
  "safety_tip4": "Zweryfikuj informacje wysyłkowe",
  "article_link": "Przeczytaj nasz pełny przewodnik Kakobuy Spreadsheet",
  "articles_title": "Artykuły i Poradniki Kakobuy",
  "articles_subtitle": "Poznaj nasze szczegółowe przewodniki i artykuły SEO, które pomogą Ci bezpiecznie i tanio kupować przez Kakobuy",
  "article_read_more": "Czytaj więcej",
  "footer_description": "Kakobuy Polska Spreadsheet Hub – Twój niezależny przewodnik po najlepszych produktach, arkuszach i poradnikach Kakobuy dla polskich kupujących.",
  "footer_privacy": "Polityka prywatności",
  "footer_disclaimer": "Zastrzeżenie",
  "footer_about": "O nas",
  "footer_rights": "© 2026 Kakobuy Polska Spreadsheet Hub. Wszelkie prawa zastrzeżone.",
  "footer_disclaimer_text": "Ta strona jest niezależnym przewodnikiem informacyjnym i nie jest powiązana z Kakobuy. Wszystkie znaki towarowe należą do ich właścicieli.",
  "nav_home": "Strona główna",
  "nav_guide": "Poradnik zakupowy",
  "nav_article": "Przewodnik",
  "dropdown_placeholder": "Wybierz kategorię produktów",
  "category_shoes": "Buty",
  "category_hoodies": "Bluzy/Swetry",
  "category_tshirts": "Koszulki",
  "category_jackets": "Kurtki",
  "category_pants": "Spodnie/Szorty",
  "category_headwear": "Nakrycia głowy",
  "category_sets": "Zestawy",
  "category_underwear": "Bielizna",
  "category_jersey": "Koszulki sportowe",
  "category_accessories": "Akcesoria",
  "category_bags": "Torby",
  "category_belts": "Paski",
  "category_perfumes": "Perfumy",
  "category_other": "Inne produkty"
}